import { render, staticRenderFns } from "./ExerciciosAssertivasPergunta.vue?vue&type=template&id=6e048058&"
import script from "./ExerciciosAssertivasPergunta.vue?vue&type=script&lang=js&"
export * from "./ExerciciosAssertivasPergunta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports